<template>
    <div class="form-group text">
        <label
            class="control-label"
            :for="name"
            v-text="label"
        ></label>
        <select
            class="form-control"
            :id="name"
            :name="name"
            v-model="country"
        >
            <option
                :key="option"
                :value="option"
                v-for="option in options"
                v-text="option"
            ></option>
        </select>
        <small
            class="text-danger"
            v-if="isCountryNotAllowed"
        >{{ country }} is not one of this product's delivery countries. Choose another country.</small>
    </div>
</template>

<script>
import {CountryData} from "../../../../config";

export default {
    name: 'CountryInput',

    props: {
        label: {
            default: 'Country',
            required: false,
            type: String,
        },
        name: {
            default: 'country',
            required: false,
            type: String,
        },
        value: {
            default: CountryData.GBR.name,
            required: false,
            type: String,
        },
        countriesList: {
            default: () => [],
            required: false,
            type: Array,
        },
    },

    data() {
        return {
            country: this.value,
        }
    },

    computed: {
        countries() {
            return this.countriesList.length > 0
                ? this.countriesList
                : Object.values(CountryData).map(value => value.name).sort();
        },
        // A country that isn't in the list (a stored order's country, or a legacy spelling) is kept
        // as an option rather than replaced, so it is still submitted and never silently changed.
        options() {
            return this.country && !this.countries.includes(this.country)
                ? [this.country].concat(this.countries)
                : this.countries;
        },
        isCountryNotAllowed() {
            return this.countriesList.length > 0 && !!this.country && !this.countriesList.includes(this.country);
        },
    },

    watch: {
        country(newVal) {
            this.$emit('input', newVal);
        },
        value(newVal) {
            Object.assign(this, {country: newVal});
            this.defaultCountryWhenBlank();
        },
        countries: {
            handler() {
                this.defaultCountryWhenBlank();
            },
            immediate: true,
        },
    },

    methods: {
        // Only a blank country is filled in. A set country the product doesn't allow is left for
        // the server's delivery-country rule to reject, with the warning above shown meanwhile.
        defaultCountryWhenBlank() {
            if (this.country || this.countries.length === 0) {
                return;
            }

            this.country = this.countries.includes(CountryData.GBR.name)
                ? CountryData.GBR.name
                : this.countries[0];
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/CountryInput.vue